import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postLiveAccountAvalaibility = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/account-livestream/availability`, data: payload });

  return data;
};

export default postLiveAccountAvalaibility;
